import styled from '@emotion/styled';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsTable } from '../components/analytics/analytics-table';
import { FileAnalyticsTable } from '../components/analytics/file-analytics-table';
import { FiltersList } from '../components/analytics/filters-list';
import { LimitAnalyticsViewNotification } from '../components/analytics/limit-analytics-view-notification';
import { Statistics } from '../components/analytics/stat-cards';
import { PageHeader } from '../components/common/page-header';
import { LocaleKeys } from '../locale';
import { isHaveLimitOnAnalyticsViewSelector } from '../state/analytics/selectors';

const Wrapper = styled.div``;

export const AnalyticsPage: FC = () => {
  const { t } = useTranslation([LocaleKeys.ANALYTICS]);

  const isHaveLimitOnAnalyticsView = isHaveLimitOnAnalyticsViewSelector();

  return (
    <div>
      <PageHeader>{t('pageTitle')}</PageHeader>
      <Wrapper>
        <FiltersList />
        <Statistics />
        {isHaveLimitOnAnalyticsView && <LimitAnalyticsViewNotification />}
        <AnalyticsTable />
        <FileAnalyticsTable />
      </Wrapper>
    </div>
  );
};
